import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { request as getStartedProgressGet } from "store/api/organization/getStartedProgressGet/getStartedProgressGetActions";
import { isNewGetStartedEnabled } from "tools/getStartedFlow";

const TEN_SECONDS = 10000;
let interval;

export const useGetStartedProgressPoll = (progress: number) => {
  const dispatch = useDispatch();
  // v2 (flag on) refreshes on user actions (getStartedAction → refresh), so it
  // must NOT be polled: the endpoint can 404/502 and we'd loop forever. Treat
  // v2 as "finished" here to disable the interval entirely.
  const finished = isNewGetStartedEnabled() || progress === 100;

  useEffect(() => {
    if (interval && finished) {
      clearInterval(interval);
    }

    if (!finished) {
      clearInterval(interval);
      interval = setInterval(() => {
        dispatch(getStartedProgressGet());
      }, TEN_SECONDS);
    }

    return () => {
      clearInterval(interval);
    };
  }, [finished, dispatch]);

  return interval;
};
